import { SpaInventory } from '../components/inventory/spa-inventory-hybrid.vue';
Vue.component('spa-inventory', SpaInventory);